import React from "react";

// Fixed palette so each person can pick a distinct color. Inline styles are
// used for these (Tailwind can't generate arbitrary user-chosen colors).
export const PALETTE = [
  { name: "Blue", value: "#3b82f6" },
  { name: "Red", value: "#ef4444" },
  { name: "Green", value: "#22c55e" },
  { name: "Amber", value: "#f59e0b" },
  { name: "Violet", value: "#8b5cf6" },
  { name: "Pink", value: "#ec4899" },
  { name: "Teal", value: "#14b8a6" },
  { name: "Orange", value: "#f97316" },
];

// Radio-style swatch picker. Colors in `disabledColors` (already taken by
// someone else) are greyed out unless they're the current selection.
export const ColorPicker = ({ selected, disabledColors = [], onPick }) => (
  <div className="flex flex-wrap gap-2">
    {PALETTE.map((c) => {
      const disabled = disabledColors.includes(c.value) && c.value !== selected;
      const isSelected = c.value === selected;
      return (
        <button
          key={c.value}
          type="button"
          title={disabled ? `${c.name} (taken)` : c.name}
          disabled={disabled}
          onClick={() => onPick(c.value)}
          className={`h-8 w-8 rounded-full border-2 transition-transform ${
            isSelected ? "scale-110 border-foreground" : "border-transparent"
          } ${disabled ? "cursor-not-allowed opacity-25" : "hover:scale-110"}`}
          style={{ backgroundColor: c.value }}
          aria-label={c.name}
        />
      );
    })}
  </div>
);
